// Functions for the create account and sign in buttons.
function createAccount() {
  if (!window.tagular) return
  window.tagular('beam', 'ElementClicked', {
    '@type': 'redventures.usertracking.v3.ElementClicked',
    webElement: {
      elementType: 'BUTTON',
      location: 'SECTION',
      position: 'BANNER',
      name: 'CARDS HUB PAGE',
      text: 'Create a free account'
    },
    actionOutcome: 'link to sign up tab',
    correlationId: 'dynamic field',
    outboundUrl:
      'https://www.bankrate.com/app/sign-in/?isSignup=true&redirect-to=https://www.bankrate.com/finance/credit-cards/?utm_content=cc-hub_auth'
  })
}

function signIn() {
  // fire some tagular events
  if (!window.tagular) return
  window.tagular('beam', 'ElementClicked', {
    '@type': 'redventures.usertracking.v3.ElementClicked',
    webElement: {
      elementType: 'BUTTON',
      location: 'SECTION',
      position: 'BANNER',
      name: 'CARDS HUB PAGE',
      text: 'Sign in'
    },
    actionOutcome: 'link to sign in',
    correlationId: 'dynamic field',
    outboundUrl:
      'https://www.bankrate.com/app/sign-in/?redirect-to=https://www.bankrate.com/finance/credit-cards/?utm_content=cc-hub_auth'
  })
}

function closeAuthBanner() {
  // Remove auth banner and set sessionStorage
  document.querySelector('.auth-banner').remove()
  window.sessionStorage.setItem('auth_banner_closed', true)

  if (!window.tagular) return
  window.tagular('beam', 'ElementClicked', {
    '@type': 'redventures.usertracking.v3.ElementClicked',
    webElement: {
      elementType: 'BUTTON',
      location: 'SECTION',
      position: 'BANNER',
      name: 'CARDS HUB PAGE',
      text: 'X'
    },
    actionOutcome: 'CLOSE',
    correlationId: 'dynamic field'
  })
}

// check localStorage to see if user has closed the auth banner.
const authBannerClosed = window.sessionStorage.getItem('auth_banner_closed')

// Check if the user is logged in through the BAEAU cookie (only checks for existence).
const loggedIn = document.cookie.match(/^(.*;)?\s*BAEAU\s*=\s*[^;]+(.*)?$/)

// Also checking the QA cookie, not necessary on prod.
const loggedInQA = document.cookie.match(/^(.*;)?\s*BAEAU-QA\s*=\s*[^;]+(.*)?$/)

// Remove banner if it was closed or user is logged in. Otherwise show the banner + add listeners.
if (authBannerClosed || loggedIn || loggedInQA) {
  document.querySelector('.auth-banner').remove()
} else {
  // initialize the Auth0 pop-up for creating a new account https://bankrate-aux.rvdocs.io/docs/guides/auth.html#auth-pop-up
  window._BedrockAuth.init({
    selector: '.cc-hub__create-account-button',
    options: {
      isSignUp: true,
      redirect: {
        redirectUrl: `https://${window.location.host}/finance/credit-cards/`
      },
      utmData: {
        content: 'cc-hub_auth'
      }
    }
  })

  // initialize the Auth0 pop-up for signing into an existing account https://bankrate-aux.rvdocs.io/docs/guides/auth.html#auth-pop-up
  window._BedrockAuth.init({
    selector: '.cc-hub__sign-in-button',
    options: {
      isSignUp: false,
      redirect: {
        redirectUrl: `https://${window.location.host}/finance/credit-cards/`
      },
      utmData: {
        content: 'cc-hub_auth'
      }
    }
  })

  document
    .querySelector('.cc-hub__create-account-button')
    .addEventListener('click', createAccount)

  document
    .querySelector('.cc-hub__sign-in-button')
    .addEventListener('click', signIn)

  document
    .querySelector('.cc-hub__auth-close-button')
    .addEventListener('click', closeAuthBanner)

  document.querySelector('.auth-banner').classList.remove('+display-none')
}
